import { atom, selector, useRecoilState, useResetRecoilState } from 'recoil';

/**
 * 공용 Confirm Message 모달
 */
// atom
const confirmModalState = atom({
  key: 'confirmModalState',
  default: {
    isOpen: false,
    title: '',
    message: '',
    isCancelBtn: false,
    isConfirmBtn: true,
    btnNm: '',
    onConfirm: () => {}
  }
});

// selector
const confirmModalSelector = selector({
  key: 'confirmMessageSelector',
  get: ({ get }) => get(confirmModalState),
  set: ({ set }, newValue) =>
    set(confirmModalState, prevState => ({ ...prevState, ...newValue }))
});

// hook
function useConfirmModalState() {
  const [confirmModal, setConfirmModal] = useRecoilState(confirmModalSelector);
  const resetConfirmModal = useResetRecoilState(confirmModalState);

  return {
    confirmModal,
    setConfirmModal,
    resetConfirmModal
  };
}

export { useConfirmModalState };
